import styled from 'styled-components'

import { Card as CardComponent, Button as AntButton } from 'src/components/Ant'

export const Button = styled(AntButton)`
  margin-left: 0.5rem;
`

export const Card = styled(CardComponent)`
  margin-bottom: 16px;
`

export const Container = styled.div`
  position: fixed;
  bottom: 0px;
  right: 15px;
`

export const Div = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  padding-bottom: 30px;
  > div > div {
    margin-left: 1rem;
  }
`

export const HotelRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
`
